import type { IBusinessUnit, IMaterialSubmission } from './businessCaseService';
import type { ISharePointFile } from './sharepointService';

export interface ICreateBusinessCaseDraft {
  businessCaseName: string;
  sharepointFile: ISharePointFile | null;
  productGpm: string;
  businessUnit: IBusinessUnit | null;
  assignNewMaterials: boolean;
  substitutionMaterials: boolean;
  materialSubmissions: IMaterialSubmission[];
  lastSaved: string;
}

const DRAFT_STORAGE_KEY = 'bct_create_business_case_draft';

export const saveDraft = (draftData: Omit<ICreateBusinessCaseDraft, 'lastSaved'>): void => {
  try {
    const draft: ICreateBusinessCaseDraft = {
      ...draftData,
      lastSaved: new Date().toISOString(),
    };
    localStorage.setItem(DRAFT_STORAGE_KEY, JSON.stringify(draft));
  } catch (error) {
    console.error('Error saving draft:', error);
  }
};

export const loadDraft = (): ICreateBusinessCaseDraft | null => {
  try {
    const draftData = localStorage.getItem(DRAFT_STORAGE_KEY);
    if (draftData) {
      return JSON.parse(draftData);
    }
    return null;
  } catch (error) {
    console.error('Error loading draft:', error);
    return null;
  }
};

export const clearDraft = (): void => {
  try {
    localStorage.removeItem(DRAFT_STORAGE_KEY);
  } catch (error) {
    console.error('Error clearing draft:', error);
  }
};

export const hasDraft = (): boolean => {
  return localStorage.getItem(DRAFT_STORAGE_KEY) !== null;
};

export const getDraftLastSaved = (): string | null => {
  const draft = loadDraft();
  return draft ? draft.lastSaved : null;
};

// Draft will expire after 24 hours (in milliseconds)
// const DRAFT_EXPIRY_MS = 24 * 60 * 60 * 1000;

// Helper to check if draft is expired
// const isDraftExpired = (draft: ICreateBusinessCaseDraft | null): boolean => {
//   if (!draft || !draft.lastSaved) return true;
//   const savedTime = new Date(draft.lastSaved).getTime();
//   const now = Date.now();
//   return now - savedTime > DRAFT_EXPIRY_MS;
// };

// --- Commented out provision for draft expiry ---
// export const loadDraft = (): ICreateBusinessCaseDraft | null => {
//   try {
//     const draftData = localStorage.getItem(DRAFT_STORAGE_KEY);
//     if (draftData) {
//       const draft = JSON.parse(draftData);
//       if (isDraftExpired(draft)) {
//         localStorage.removeItem(DRAFT_STORAGE_KEY);
//         return null;
//       }
//       return draft;
//     }
//     return null;
//   } catch (error) {
//     console.error('Error loading draft:', error);
//     return null;
//   }
// };

// export const hasDraft = (): boolean => {
//   const draft = loadDraft();
//   return draft !== null;
// };